import React, {memo, useState} from 'react'
import './scss/InitialMap.scss'
import CancelIcon from '@material-ui/icons/Cancel';
import { GoogleMap, Marker, InfoWindow, useLoadScript } from '@react-google-maps/api'

const InitialMap = (props) => {

    const libraries = ["places"]

    const {isLoaded, loadError} = useLoadScript({
        googleMapsApiKey: "AIzaSyDCEQmQGTaR1olWVIrrocz6QSbHtJ9NImo",
        libraries
    })

    const [selectedProperty, setSelectedProperty] = useState(null)
    
    if(loadError) return "Error Loading Maps"

    if(!isLoaded) return "Loading Maps"

    return(
        <div>
            <GoogleMap 
                    mapContainerStyle={{height:600, width:'100vw'}}
                    zoom={13} 
                    center={{ lat:40.720670, lng:-73.846320 }}
                    options={{styles :
                        [
                            {
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#f5f5f5"
                                }
                              ]
                            },
                            {
                              "elementType": "labels.icon",
                              "stylers": [
                                {
                                  "visibility": "off"
                                }
                              ]
                            },
                            {
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#616161"
                                }
                              ]
                            },
                            {
                              "elementType": "labels.text.stroke",
                              "stylers": [
                                {
                                  "color": "#f5f5f5"
                                }
                              ]
                            },
                            {
                              "featureType": "administrative.land_parcel",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#bdbdbd"
                                }
                              ]
                            },
                            {
                              "featureType": "poi",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#eeeeee"
                                }
                              ]
                            },
                            {
                              "featureType": "poi",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#757575"
                                }
                              ]
                            },
                            {
                              "featureType": "poi.park",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#e5e5e5"
                                }
                              ]
                            },
                            {
                              "featureType": "poi.park",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#9e9e9e"
                                }
                              ]
                            },
                            {
                              "featureType": "road",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#ffffff"
                                }
                              ]
                            },
                            {
                              "featureType": "road.arterial",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#757575"
                                }
                              ]
                            },
                            {
                              "featureType": "road.highway",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#dadada"
                                }
                              ]
                            },
                            {
                              "featureType": "road.highway",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#616161"
                                }
                              ]
                            },
                            {
                              "featureType": "road.local",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#9e9e9e"
                                }
                              ]
                            },
                            {
                              "featureType": "transit.line",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#e5e5e5"
                                }
                              ]
                            },
                            {
                              "featureType": "transit.station",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#eeeeee"
                                }
                              ]
                            },
                            {
                              "featureType": "water",
                              "elementType": "geometry",
                              "stylers": [
                                {
                                  "color": "#c9c9c9"
                                }
                              ]
                            },
                            {
                              "featureType": "water",
                              "elementType": "labels.text.fill",
                              "stylers": [
                                {
                                  "color": "#9e9e9e"
                                }
                              ]
                            }
                          ]
                    }}
                >
                {props.properties.map((property,index)=>(
                    <Marker 
                        key={property._id}
                        position={{ lat: property.coordinates.lat, lng: property.coordinates.lng }} 
                        onClick={()=>{setSelectedProperty(property)}}
                        icon={{
                            url: '/images/location.png',
                            anchor: new window.google.maps.Point(20, 20),
                            scaledSize: new window.google.maps.Size(40, 40),
                            origin: new window.google.maps.Point(0, 0),
                        }}
                    >
                    </Marker>
                ))}

                {selectedProperty ? (
                    <InfoWindow
                        options = {
                            "stylers"
                        }
                        position={{
                            lat: selectedProperty.coordinates.lat,
                            lng: selectedProperty.coordinates.lng
                        }}
                        onCloseClick={()=>{
                            setSelectedProperty(null)
                        }}
                    >
                        <div className="map-property-thumb">
                            <a href="/propertyDetail">
                              <img src="/images/house.jpeg" alt="house" />
                            </a>
                           
                            <div className="p-2">
                                <h5>Plaza Office</h5>
                                <p><strong>$1300/month</strong><br />Bedrooms: 1 Bathrooms: 1</p>
                            </div>
                            
                           <div className="close" onClick={()=>setSelectedProperty(null)}><CancelIcon /></div>
                        </div>
                    </InfoWindow>
                    
                ) : null}
            </GoogleMap>
        </div>      
    )
    
  };
  
  export default memo(InitialMap)